import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import styles from './PlayerCard.module.scss';

export default function PlayerCard({
  name,
  onClick,
}: {
  name: string;
  onClick: () => void;
}) {
  return (
    <Box className={styles.wrapper}>
      <Card className={styles.card} onClick={onClick}>
        <CardContent className={styles.cardContent}>
          <Typography variant="h6" className={styles.name}>
            {name}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
